import React, { useEffect } from 'react';
import { setSubProduct } from '@atlassian/jira-platform-router-utils/src/common/utils/index.tsx';
import { useSubProduct, useSubProductForAnalytics } from '@atlassian/jira-subproduct/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const SubProductUpdaterOld = () => {
	const subProduct = useSubProduct();
	useEffect(() => {
		setSubProduct(subProduct);
	}, [subProduct]);

	return null;
};

const SubProductForAnalyticsUpdater = () => {
	if (fg('jpd_accurate_subproduct_for_discovery_projects')) {
		return <SubProductUpdaterNew />;
	}

	return <SubProductUpdaterOld />;
};

const SubProductUpdaterNew = () => {
	const subProduct = useSubProductForAnalytics();
	useEffect(() => {
		setSubProduct(subProduct);
	}, [subProduct]);

	return null;
};

export { SubProductForAnalyticsUpdater };
